<template>
  <b-form @submit.prevent="handleSubmit()">
    <div class="lead">{{$t('passwordRecovery.title')}}</div>
    <div class="form-group mt-3">
      <label for="_password" class="control-label">{{ $t("user.field.newPassword") }}</label>
      <b-form-input v-model="password" type="password" required id="_password"/>
    </div>
    <div class="form-group mt-3">
      <label for="_password_check" class="control-label">{{ $t("user.field.passwordCheck") }}</label>
      <b-form-input v-model="password_check" type="password" required id="_password_check" />
    </div>
    <button type="submit" class="btn btn-primary">{{ $t("global.form.submit") }}</button>
  </b-form>
</template>

<script>
  import {validateEmail} from "../../helper";
  import {mapGetters} from "vuex";

  export default {
    data: () => {
      return {
        success: false,
        password: '',
        password_check: ''
      }
    },
    computed: mapGetters({
      passwordRecoveryError: "user/passwordRecovery/error"
    }),
    methods: {
      handleSubmit() {
        if (!(this.password && this.password_check) || this.password !== this.password_check) {
          this.$notify.error(this.$t('passwordRecovery.error.passwordsNoMatch'));
          return null;
        }

        this.$store.dispatch("user/passwordRecovery/submitWithToken",
          {token: this.$route.params.token, password: this.password}
        ).then(() => {
          this.$router.push({name:'PostList'}, this.$notify.success(this.$t("passwordRecovery.success")));
        });

      },
      validateEmail,
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/PasswordRecoveryToken.vue